module.exports = __webpack_public_path__ + "img/Grundriss Dach.ee0b7de6.jpg";